import {Occupancy} from "@variocube/app-api";
import {findBoxByNumber} from "@variocube/app-common";
import {BoxAccess, PendingView, useAsync, usePlatform, usePreventDeactivate, View} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {useLocalization} from "../../i18n";

interface PickupFlowProps {
    occupancy: Occupancy;
    onDone: () => void;
}

export function PickupFlow({occupancy, onDone}: PickupFlowProps) {
    const platform = usePlatform();
    const {t} = useLocalization();

    usePreventDeactivate();

    const {result: box} = useAsync(() => findBoxByNumber(platform, occupancy.boxNumber), [platform, occupancy]);

    const handleConfirm = useCallback(async () => {
        try {
            await platform.endOccupancy(occupancy.uuid, {
                content: {
                    pickupBy: "Shop"
                },
                merge: true,
            });
        } catch (error) {
            console.error("Error ending occupancy", error);
            alert(error);
        } finally {
            onDone();
        }
    }, [platform, occupancy]);

    const {order} = occupancy.content;

    if (box) {
        return (
            <View>
                <BoxAccess
                    boxes={box}
                    platform={platform}
                    onConfirm={handleConfirm}
                    onCancel={onDone}
                    allowCancelWhenOpen
                    autoConfirm={30}
                    boxOpenTitle={t("ShopPickupTitle", {box, order})}
                    boxOpenMessage={t("ShopPickupMessage", {box, order})}
                    confirmTitle={t("ShopPickupConfirmTitle", {box, order})}
                    confirmMessage={t("ShopPickupConfirmMessage", {box, order})}
                    strings={t}
                />
            </View>
        );
    }
    else {
        return <PendingView message={t("PickupPending")}/>;
    }

}
